import React from 'react';

import IconAvatarGroup from '@components/Images/Rebranding/IconAvatarGroup';
import IconBillLong from '@components/Images/Rebranding/IconBillLong';
import IconGlobeWithinSheet from '@components/Images/Rebranding/IconGlobeWithinSheet';
import IconOrgChartWithBorder from '@components/Images/Rebranding/IconOrgChartWithBorder';

import Benefit from './Benefit';

const Benefits = () => {
  return (
    <div
      data-test="benefits"
      className="mt-48 border-0 border-t border-solid border-grayscale-beige px-16 pt-48 sm:mx-28 sm:px-0 xl:mx-[200px] xl:mt-64 xl:pt-64"
    >
      <div className="grid flex-col items-center justify-center gap-x-48 sm:grid-cols-2 sm:gap-x-96 xl:gap-x-[91px] xl:gap-y-[104px]">
        <Benefit
          Icon={IconAvatarGroup}
          heading="Subscription discounts based on group size"
          description="Scalable invoicing customized for your needs, with the flexibility to swap users and grow whenever needed."
        />
        <Benefit
          Icon={IconBillLong}
          heading="Simplified billing and account management"
          description="One invoice and renewal date for all of your users to make administration simple, handled by a dedicated team so you can focus on the work."
        />
        <Benefit
          Icon={IconGlobeWithinSheet}
          heading="Expertly reported, impactful journalism"
          description="Our team breaks the biggest stories in the tech world, making sure you’re up to date on everything happening in Silicon Valley and beyond."
        />
        <Benefit
          Icon={IconOrgChartWithBorder}
          iconClassName="text-primary-magenta"
          heading="Connect with potential clients, partners and talent"
          description="Directly connect with leaders at the most important technology and finance companies in the world through our Directory and Org Charts."
        />
      </div>
    </div>
  );
};

export default Benefits;
